import {
  Address,
  AddressForm,
  AddressResponseData,
  AddressTypes,
  AssetFormData,
  BaseAddress,
  DigitalAddress,
  EmailAddressForm,
  ErrorType,
  FormValidation,
  GetAddresses,
  QuickAddresses,
  QuickAddressesResponse,
  QuickAddressResponse,
  RecipientResponseData,
  SaveAddressResponse,
} from './addresses';
import {
  AddToCartParams,
  AddToCartResponse,
  CartData,
  MiniCart,
  MockCartUtility,
  RecentBasket,
  RequestBody,
} from './basket';
import {
  Breakpoints,
  CanvasJson,
  CustomFabricImage,
  CustomFabricObject,
  EditCanvasJson,
  FabricObject,
  FabricTextBox,
  ObjectJson,
} from './canvas';
import { CardType } from './card';
import {
  CardEditableArea,
  CardFace,
  CardFaceData,
  CardFacePreviewImage,
  CardText,
  EditableTextSettings,
  EditableZoneSettings,
} from './card-face';
import { GetProjectAsset, GetProjectResponseData } from './digital-greetings';
import { ConfirmProjectDetailsRequestBody, DigitalOrderRequestBody } from './digital-orders';
import { EnvelopePreviewBody, EnvelopePreviewResponse } from './envelope';
import { Font, OpenTypeFont } from './font';
import { AccountProfileResponse, FulfillmentResponse, PreviewFormData, PreviewResponseData } from './fulfillment';
import {
  cleanUpFormData,
  CleanUpImageResponse,
  cropAndRotateFormData,
  CropAndRotateResponse,
  ImageResponse,
  linkPhotoFormData,
  LinkPhotoResponse,
  PreviewLabel,
} from './images';
import { InitBody, InitializationData, ProjectAsset, ProjectTypeCode, TemplateData } from './initialization-data';
import { CustomerAuthResponseData, HallmarkMembershipStatus } from './membership';
import { PhotoTextZoneConfig, PhotoTextZoneSettings } from './photo-text-zone';
import { RegionalCodesList } from './regions-list';
import { DEFAULT_PROJECT_NAMES } from './save-project';
import { ApiResponse, ErrorResponse, Meta, SuccessNoContentResponse } from './services';
import { SpellcheckErrors, SpellcheckSuggestion } from './spellcheck';
import { BottomPadding, IconPosition } from './utility';

declare global {
  interface Window {
    fabric: any;
    _satellite?: any;
    initEmbeddedMessaging?: () => void;
  }
}

window.fabric = window.fabric || {};

export type {
  Font,
  OpenTypeFont,
  InitializationData,
  CardFace,
  CardEditableArea,
  CardFacePreviewImage,
  CardFaceData,
  CardText,
  EditableTextSettings,
  EditableZoneSettings,
  ImageResponse,
  LinkPhotoResponse,
  SaveAddressResponse,
  BaseAddress,
  Address,
  DigitalAddress,
  FormValidation,
  AddressForm,
  EmailAddressForm,
  AddressResponseData,
  FulfillmentResponse,
  PreviewResponseData,
  PreviewFormData,
  AccountProfileResponse,
  GetProjectAsset,
  GetProjectResponseData,
  EnvelopePreviewResponse,
  EnvelopePreviewBody,
  MiniCart,
  QuickAddressResponse,
  QuickAddressesResponse,
  CleanUpImageResponse,
  CropAndRotateResponse,
  linkPhotoFormData,
  cleanUpFormData,
  cropAndRotateFormData,
  TemplateData,
  CartData,
  RequestBody,
  AddToCartResponse,
  RecentBasket,
  AddToCartParams,
  MockCartUtility,
  GetAddresses,
  ProjectTypeCode,
  QuickAddresses,
  ApiResponse,
  ErrorResponse,
  Meta,
  InitBody,
  ProjectAsset,
  SuccessNoContentResponse,
  CanvasJson,
  EditCanvasJson,
  FabricObject,
  ObjectJson,
  Breakpoints,
  FabricTextBox,
  CustomFabricObject,
  CustomFabricImage,
  AssetFormData,
  RecipientResponseData,
  DigitalOrderRequestBody,
  ConfirmProjectDetailsRequestBody,
  PhotoTextZoneConfig,
  PhotoTextZoneSettings,
  SpellcheckErrors,
  SpellcheckSuggestion,
  CustomerAuthResponseData,
  HallmarkMembershipStatus,
};

export {
  CardType,
  ErrorType,
  AddressTypes,
  DEFAULT_PROJECT_NAMES,
  RegionalCodesList,
  PreviewLabel,
  BottomPadding,
  IconPosition,
};
